import { CampaignResponseModel } from '../../../../models/campaign-response.model';
import { VehiclePopulationFormikModel } from '../../models/vehicle-population-formik.model';

export const vehiclePopulationResponseModelToFormik = (
  data: CampaignResponseModel
): VehiclePopulationFormikModel => ({
  vinCriteria: data.vinCriteria.length ? data.vinCriteria : [''],
});
